/**
 * Created by akirilyuk on 9/7/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/extendedList/ticketAttachmentItemView.tmpl"),
        AttachmentModel = require("connection-models/ticketTab/AttachmentModel"),
        Button = require("ui/button/Button"),
        TicketAttachmentItemView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketAttachmentItemView = Marionette.ItemView.extend({
            template: template,
            className: 'attachment-view',
            model: AttachmentModel,
            ui: {
                attachmentLink : ".attachment-button",
                attachmentRemove : ".attachment-remove-button"
            },
            uiComponents:{
                attachmentLink: {
                    type: Button,
                    options: {
                        el: "view.ui.attachmentLink",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        click: "_downloadAttachment"
                    }
                },
                attachmentsRemove: {
                    type: Button,
                    options: {
                        el: "view.ui.attachmentRemove",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        click: "_removeAttachment"
                    }
                }
            },
            initialize: function(options){
                this.model = options.model;
                this.filename = this.model.get("filename");
            },
            onRender: function () {
                if(!this.model.get("unsaved")){
                    this.uiComponents.attachmentsRemove.hide();
                }else{
                    this.uiComponents.attachmentLink.setState(Button.STATES.DISABLED);
                }
            },
            _downloadAttachment: function() {
                var startNotifier = LEConnection.notifier.showInfoExtended(LE.translator.translate("LEConnection.cases.attachmentDownload.info.start"));
                this.model.fetch({
                    success: function (model, response, options) {
                        startNotifier.close();
                        LEConnection.logger.debug("fetch content success - file will download", "TicketViewController:_downloadAttachment");
                    },
                    error: _.bind(function (model, response, options) {
                        startNotifier.close();
                        LEConnection.notifier.showErrorExtended(LE.translator.translate("LEConnection.cases.attachmentDownload.error.failed"));
                    },this)
                });
            },
            _removeAttachment: function(){
                this.removeCallback(this.model);
            },
            setRemoveCallback: function(callback){
                this.removeCallback = callback;
            }
        });
    });
    return TicketAttachmentItemView;
});
